import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from 'styled-components';
import { useEffect, useRef, useState } from 'react';
import { ChatIcon } from '../assets';
import Typography from '../typography/Typography';
import { TransparentButton } from '../transparent-button/TransparentButton';
import { IconWrapper, NotificationAlert } from './styles';
const HeaderChat = ({ className, chatButtonId, chatIconId, }) => {
    const { colors } = useTheme();
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [_, setIsChatOpen] = useState(false);
    const [unreadCount, setUnreadCount] = useState(0);
    const timeoutRef = useRef();
    const clearTimeoutCache = () => {
        if (!timeoutRef.current)
            return;
        clearTimeout(timeoutRef.current);
        timeoutRef.current = undefined;
    };
    const handleChatVisibility = (isChatOpen) => {
        if (window.isFromMobileApp)
            return;
        const timeout = 0;
        clearTimeoutCache();
        timeoutRef.current = setTimeout(() => {
            const chatCommand = isChatOpen ? 'show' : 'hide';
            window?.zE?.('messenger', chatCommand);
        }, timeout);
    };
    const toggleChat = () => {
        setIsChatOpen((prev) => {
            const isChatOpen = !prev;
            const zendeskTarget = 'messenger';
            const zendeskEventName = isChatOpen ? 'open' : 'close';
            window?.zE?.(zendeskTarget, zendeskEventName);
            handleChatVisibility(isChatOpen);
            return isChatOpen;
        });
    };
    useEffect(() => {
        if (window.isFromMobileApp) {
            window?.zE?.('messenger', 'hide');
        }
        handleChatVisibility(false);
        window?.zE?.('messenger:on', 'close', () => {
            setIsChatOpen(false);
            handleChatVisibility(false);
        });
        window?.zE?.('messenger:on', 'unreadMessages', (count) => {
            if (typeof count === 'number') {
                setUnreadCount(count);
            }
        });
        return () => {
            clearTimeoutCache();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (_jsx(TransparentButton, { onClick: toggleChat, className: className, id: chatButtonId, children: _jsxs(IconWrapper, { color: colors.surface.interactiveDefault, className: "icon-wrapper", children: [unreadCount > 0 && (_jsx(NotificationAlert, { children: _jsx(Typography, { type: "caption", fontFamily: "primaryBold", color: colors.text.interactive, children: unreadCount }) })), _jsx(ChatIcon, { id: chatIconId })] }) }));
};
export default HeaderChat;
//# sourceMappingURL=HeaderChat.js.map